import { Outlet, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

import { Footer } from "../navigation/footer/footer";

import './layout.css'

export const Layout = () => {
    const location = useLocation();
    return (
        <>
        <main key={location.pathname}>
            <AnimatePresence mode="wait">
              <motion.div key={location.key}>
                <Outlet />
              </motion.div>
            </AnimatePresence>
        </main>
        <Footer />
      </>
    );
}
